import Component from "@glimmer/component";
import { service } from "@ember/service";
import { on } from "@ember/modifier";
import { task } from "ember-concurrency";
import { eq } from "ember-truth-helpers";
import { t } from "ember-intl";
import ENV from "glesys-controlpanel/config/environment";
import Box from "glesys-controlpanel/components/box";
import Table from "glesys-controlpanel/components/table";
import TableTd from "glesys-controlpanel/components/table/td";
import TableTh from "glesys-controlpanel/components/table/th";
import Copyable from "glesys-controlpanel/components/copyable";
import GButton from "glesys-controlpanel/components/g-button";
import Dropdown from "glesys-controlpanel/components/dropdown";
import DropdownDestructiveItem from "glesys-controlpanel/components/dropdown/destructive-item";
import IconsMoreVertical from "glesys-controlpanel/components/icons/more-vertical";
import canManage from "glesys-controlpanel/helpers/can-manage";
import modal from "glesys-controlpanel/helpers/modal";

export default class DatabasesBox extends Component {
  @service http;
  @service store;

  get instanceDatabases() {
    return this.args.database.instanceDatabases ?? [];
  }

  createDatabaseTask = task(async (name) => {
    let response = await this.http.request({
      method: "POST",
      url: `${ENV.apiBaseUri}/database/createdatabase`,
      body: { instanceid: this.args.database.id, name },
    });

    this.store.pushPayload("database", { database: response.content.database });
  });

  <template>
    <Box data-test-database-details-databases @showFooter={{(canManage)}}>
      <:header>{{t "databases.details.databases.title"}}</:header>
      <:default>
        <Table class="mx-[-25px]" @items={{this.instanceDatabases}} @footer={{false}} @outsideBorders={{false}}>
          <:header>
            <TableTh>{{t "databases.details.databases.columns.name"}}</TableTh>
            <TableTh><span class="sr-only">{{t "label.actions"}}</span></TableTh>
          </:header>
          <:body as |entry|>
            <TableTd>
              <Copyable>{{entry.name}}</Copyable>
            </TableTd>
            <TableTd>
              {{#if (canManage)}}
                {{#unless (eq entry.name "defaultdb")}}
                  <div class="flex justify-end">
                    <Dropdown
                      aria-label={{t "label.action-menu-aria-label" name=entry.name}}
                      data-test-database-database-menu={{entry.name}}
                      @chevron={{false}}
                    >
                      <:header>
                        <IconsMoreVertical class="w-5" />
                      </:header>
                      <:default>
                        <DropdownDestructiveItem
                          data-test-database-database-delete
                          {{on
                            "click"
                            (modal
                              "modals/organism-delete"
                              entity=entry.name
                              entityKey=entry.name
                              task=entry.deleteTask
                              leadText=(t "databases.details.databases.delete.warning")
                            )
                          }}
                        >
                          {{t "button.delete"}}
                        </DropdownDestructiveItem>
                      </:default>
                    </Dropdown>
                  </div>
                {{/unless}}
              {{/if}}
            </TableTd>
          </:body>
        </Table>
      </:default>
      <:footer>
        <GButton
          data-test-database-databases-create
          @color="outline"
          {{on "click" (modal "modals/database-create-database" task=this.createDatabaseTask)}}
        >
          {{t "databases.details.databases.create.button"}}
        </GButton>
      </:footer>
    </Box>
  </template>
}
